import { PriceRow } from 'server/types';
import * as fmt from 'shared/payments/fmt';
import { aipAnchorPrice } from 'shared/mirasee-consts';

/**
 * Renders the AI Playground price with the "founding rate" framing: the
 * positioned $200/month rate struck through, followed by the real price the
 * member actually pays, labelled "founding rate". The anchor is display-only —
 * it does not affect what Stripe charges. Mirrors the cancellation-flow copy in
 * subscription-status.tsx. Returns an inline fragment so callers control layout.
 *
 * The anchor is set per currency (see aipAnchorPriceDisplay). A currency with
 * no anchor shows the price on its own, because borrowing another currency's
 * figure would advertise a discount nobody agreed to.
 */
export function AipFoundingRatePrice({
  price,
}: {
  price: Pick<PriceRow, 'priceInCents' | 'currency' | 'interval'>;
}) {
  const interval = price.interval ? `/${price.interval}` : '';
  const anchor = aipAnchorPrice(price.currency);
  if (!anchor) {
    return (
      <span class="font-medium text-gray-700 dark:text-gray-200">
        {fmt.price(price)}
        {interval}
      </span>
    );
  }
  return (
    <>
      <span class="line-through text-gray-400 dark:text-gray-500">
        {fmt.price(anchor)}
        {interval}
      </span>{' '}
      <span class="font-medium text-gray-700 dark:text-gray-200">
        {fmt.price(price)}
        {interval} founding rate
      </span>
    </>
  );
}
